module.exports = __webpack_public_path__ + "static/media/icariusIcon.27509318.png";